<template>
  <ul>
    <!-- NUMBER LIST ON ALL MESSAGES SEPARATE -->
    <li v-for="(numberData, ind) in numberDataList" :key="numberData.number">
      <section
        v-if="numberData.number !== '0'"
        class="card"
        :class="openedList.includes(numberData.number) ? 'opened' : 'hidden'"
      >
        <div class="button_cell">
          <button
            class="btn_toggle"
            @click="onExtendClick(tableTitle, numberData.number)"
          >
            {{ openedList.includes(numberData.number) ? "-" : "+" }}
          </button>
        </div>
        <!-- LIST INFORMATION ABOUT NUMBER -->
        <ul class="number_information_list">
          <!-- NUMBER CELLS -->
          <li
            v-for="(titleHeader, index) in $tm(
              `page.integration.numbers_table.connected_header`
            )"
            :key="index"
            class="number_information number_cell"
            :class="[columnClassList[index]]"
          >
            <!-- TITLES -->
            <div
              v-show="openedList.includes(numberData.number)"
              class="title"
              :class="`title-${columnClassList[index]}`"
            >
              {{ titleHeader }}
            </div>
            <div
              :class="[
                `${columnClassList[index]}-value`,
                statusNumber(numberData)?.status,
              ]"
            >
              <!-- NUMBER -->
              <template v-if="columnClassList[index] === 'number'">
                <div
                  class="number-container"
                  :style="customColumnNumberStyle(numberData.number, numberData.tags)"
                >
                  <img
                    class="icon"
                    :src="require(`@/assets/icons/${tableTitle}.svg`).default"
                  />
                  <div class="number_with_tags">
                    <span>{{ numberData.number }}</span>
                    <BaseTag :tag="numberData.tags[0]" typeClass="table" />
                  </div>
                </div>
                <!-- ICON STATUS IN NUMBER -->
              </template>

              <!-- INTEGRATIONS -->
              <template v-if="columnClassList[index] === 'integration'">
                <ul
                  v-if="numberData.integrations.length > 0"
                  class="text-uppercase"
                  :class="[numberData.integrations.length > 5 && 'moreCrm']"
                >
                  <li class="headed_text" v-for="crm in numberData.integrations">
                    {{ crm === 'kwizbot' ? 'connectiveone' : crm }}
                  </li>
                </ul>
                <p v-else>-</p>
              </template>
              <!-- PAID TO -->
              <template v-if="columnClassList[index] === 'paid_to'">
                <span
                  :class="{ warning_status: !numberData.tariff_end_date }"
                  v-text="
                    numberData.tariff_end_date ||
                    $t('page.integration.numbers_table.connected_numbers.aсtivation_msg')
                  "
                />
              </template>
              <!-- TARIFF -->
              <template v-if="columnClassList[index] === 'tariff'">
                <span v-text="numberData.tariff || '-'" />
              </template>

              <!-- !! CHECK AND REMOVE -->
              <!-- STATUS -->
              <template v-if="columnClassList[index] === 'status'">
                <div
                  v-if="!openedList.includes(numberData.number) && width <= 950"
                  class="status icon_status mt-1"
                  :class="statusNumber(numberData)?.status"
                >
                  <i
                    class="bi bi-circle-fill"
                    :title="
                      $t(
                        `page.integration.numbers_table.connected_numbers.${
                          statusNumber(numberData)?.status
                        }`
                      )
                    "
                  />
                </div>
                <slot v-else name="status" :number="numberData" />
              </template>
              <!-- API KEY -->
              <template v-if="columnClassList[index] === 'api_key'">
                <div class="api_key">{{ numberData.api_key }}</div>
              </template>
              <!-- SETTINGS -->
              <template v-if="columnClassList[index] === 'settings'">
                <slot name="settings" :number="numberData" />
              </template>
              <!-- ACTIONS -->
              <template v-if="columnClassList[index] === 'actions'">
                <slot name="actions" :number="numberData"> </slot>
              </template>
            </div>
          </li>
        </ul>
      </section>
    </li>
  </ul>
  <div v-if="tableStatus">
    <InfoDataTextRecurring :value="tableStatus" height="120px" />
  </div>
  <slot name="pagination" />
</template>

<script setup>
import { ref, reactive, computed, onUnmounted } from "vue";
import BaseTag from "@/components/ui/BaseTag.vue";
import InfoDataTextRecurring from "@/components/Recurring/InfoDataTextRecurring.vue";
import statusNumberConfig from "./configs/statusNumberConfig";
import { useStore } from "vuex";
import { useWindowSize } from "@vueuse/core";
import BasePagination from "@/components/ui/BasePagination.vue";

// TODO: refactor
const columnClassList = [
  "number",
  "integration",
  "paid_to",
  "tariff",
  "status",
  "api_key",
  "settings",
  "actions",
];

const store = useStore();
const { width } = useWindowSize();

const selectButton = ref("");
const openedList = reactive([]);

const props = defineProps({
  numberDataList: {
    type: Array,
    require: true,
  },
  tableTitle: {
    // TODO: renamed
    type: String, // "viber", "telegram"
    require: true,
  },
  tableType: {
    type: String, // 'visible' || 'invisible'
    require: true,
  },
  // 'loading' | 'noNumbers' | null - null means the list has rows
  tableStatus: {
    type: String,
    default: null,
  },
});

const emits = defineEmits(["loadMore"]);
const isIconStatus = computed(() => (width.value < 820 ? true : false));

const onExtendClick = (msg, number) => {
  const visibility = props.tableType === "visible";

  if (openedList.includes(number)) {
    openedList.splice(openedList.indexOf(number), 1);
  } else {
    openedList.push(number);
  }
};

// WINDOW RESIZE COMPONENTS STYLES
// NUMBER CELL
const customColumnNumberStyle = (number, numberTags) => {
  const isOpened = openedList.includes(number);
  if (isOpened) {
    return {
      //   justifyContent: "center",
      marginTop: "0px",
      //   transition: "justify-content 0.7s ease",
    };
  } else {
    if (!numberTags.length) {
      return {
        // marginTop: "5px",
        transitionAnimation: "margin-top",
        transitionDelay: "0.5s",
      };
    }

    return {
      //   justifyContent: "start",
      //   transition: "justify-content 0.7s ease",
      transitionDelay: "0.5s",
    };
  }
};

// !! CHECK AND REMOVE
const statusNumber = (num) => {
  const { status, buttonText } = statusNumberConfig(num);
  return { status, buttonText };
};
</script>

<style lang="scss" scoped>
@use "@/styles/table.scss";

.card {
  overflow: hidden;
  background-color: var(--block-color);
  border-radius: 11px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;
  text-align: center;
  transition: max-height 0.7s ease;
  .title {
    font-weight: 600;
    font-size: 14px;
    text-transform: uppercase;
    margin-bottom: 5px;
  }
}

.moreCrm {
  height: 120px;
  overflow-y: auto;
  margin-bottom: 5px;
  margin-right: 5px;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-track {
    background: white;
  }
  &::-webkit-scrollbar-thumb {
    background: #7970dfbf;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: var(--general-color);
  }
}

.hidden {
  .integration,
  .tariff,
  .status,
  .settings,
  .paid_to,
  .actions,
  .api_key {
    display: none;
  }
}

.number_information_list {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: space-between;
  gap: 10px;
  flex: 1;
  padding: 5px 10px 0 0;
}

.button_cell {
  margin: 10px;
}

.btn_toggle {
  font-size: 20px;
  color: #7a70df;
  width: 27px;
  padding: 0;
  height: 27px;
  background: white;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.number_cell {
  border-bottom: none;
  &.number {
    margin: 0;
  }
  &.settings {
    flex: 0 0 100%;
  }
  .settings-value {
    width: fit-content;
  }
  &.status,
  &.actions,
  &.settings {
    padding-bottom: 6px;
  }
  &.settings {
    flex: 0 0 100%;
  }
  &.paid_to {
    width: 90px;
  }
  &.actions {
    max-width: 190px;
    width: 100%;
  }

  .number-value {
    display: flex;
    width: 100%;
  }
  .actions-value {
    text-align: right;
  }
  .settings-value {
    width: fit-content;
  }
}
.title-actions {
  //   visibility: hidden;
}

.opened {
  max-height: 800px;
  .number_information_list {
    padding-top: 10px;
  }
  .number_cell {
    border-bottom: 1px solid rgba(122, 112, 223, 0.15);
    display: block;
    flex: 100%;
    text-align: left;
    &.settings {
      max-width: 100%;
    }
  }
}
.status-value {
  font-size: 15px;
  transition: none;
  min-width: 190px;
  //   max-width: 220px;
  //   margin: 0 auto;
}

.number-container {
  width: 145px;
  flex: 1;
}

.tags {
  margin-left: -10px;
  margin-top: -3px;
  min-width: 130px;
}

.icon {
  margin-top: 4px;
}

.icon_status {
  width: fit-content;
}

::-webkit-scrollbar {
  width: 6px;
}
.hidden {
  .number_information {
    margin: auto 0;
  }
}

@media screen and (min-width: 420px) {
  .card.hidden {
    // gap: 15px;
  }
  .hidden {
    .status {
      display: block;
      @media (max-width: 950px) {
        margin-right: auto;
      }
    }
  }
}
@media (max-width: 950px) {
  .status-value {
    min-width: auto;
  }
  .hidden .status-value {
    padding-left: 15px;
  }
}

@media screen and (min-width: 560px) {
  .opened .number_cell {
    flex: 1 1 40%;
    min-height: 94px;
    &.settings {
    }
    .title-settings,
    .title-actions {
      visibility: hidden;
    }
    .api_key-value {
      margin-top: 10px;
    }
  }
  .settings-value {
    margin-left: auto;
  }
}

@media screen and (min-width: 620px) {
  .hidden .actions {
    display: block;
  }
}

@media screen and (min-width: 800px) {
  .card {
  }
  .opened {
    .number_cell {
      flex: 1 1 25%;
    }
  }
  .hidden {
    .number_cell {
      flex: 0 0 auto;
      &.settings {
        flex: none;
      }
    }
    .status {
      //   flex: 1 0 auto;
    }
    .settings {
      display: block;
    }
  }
  .actions {
    width: 100%;
  }
}

@media screen and (min-width: 880px) {
  .hidden {
    .number_cell {
      //   flex: 1;
    }
    .paid_to {
      display: block;
    }
    .paid_to {
      flex: 0.2 0 auto;
    }
    .status {
      //   max-width: 200px;
    }
    .actions {
      flex: 3;
    }
    .settings-value {
      margin: auto;
    }
  }
  .icon_status {
    display: block;
  }
}

.integration-value {
  container-type: inline-size;
}

@container (min-width: 191px) {
  .integration-value {
    .moreCrm {
      display: flex;
      column-gap: 5px;
      flex-wrap: wrap;
      overflow: hidden;
      height: auto;
      line-height: 1.2rem;
    }
    .headed_text:not(:last-child):after {
      content: ", ";
    }
  }
}
</style>
